import Api from './baseApi';

export default {
  list: (companyId, status) => Api.get('/api/cashaccounts', { params: { companyId, status } }),
  get: (id) => Api.get(`/api/cashaccounts/${id}`),
  create: (payload) => Api.post('/api/cashaccounts', payload),
  update: (id, payload) => Api.put(`/api/cashaccounts/${id}`, payload),
  remove: (id) => Api.delete(`/api/cashaccounts/${id}`),
  addIncome: (payload) => Api.post('/api/cashaccounts/income', payload),
  externalPayment: (payload) => Api.post('/api/cashaccounts/external-payment', payload),
  transfer: (payload) => Api.post('/api/cashaccounts/transfer', payload),
  adjust: (payload) => Api.post('/api/cashaccounts/adjust', payload),
  getHistory: (subType, date) => Api.get('/api/cashaccounts/history', { params: { subType, date } }),
  getMyAccounts: () => Api.get('/api/cashaccounts/my-accounts'),
  getMyHistory: (subType, date) => Api.get('/api/cashaccounts/my-history', { params: { subType, date } }),
  getSnapshots: (startDate, endDate) => Api.get('/api/cashaccounts/snapshots', { params: { startDate, endDate } }),
};
